import {Component, OnInit} from '@angular/core';
import {BaseComponent} from '../BaseComponent';
import {ActivatedRoute, Router} from '@angular/router';
import {urlDev} from '../../services/api/servers';
import {LoginService} from '../../services/login.service';
import {HttpClient} from '@angular/common/http';
import {UserService} from '../../services/api/UserService';
import {LoaderService} from '../general-services/service-loader/loader.service';
import {FormBuilder} from '@angular/forms';
import {User} from '../../models/User';

@Component({
  selector: 'app-login',
  templateUrl: './loginADFS.component.html',
  styleUrls: ['./loginADFS.component.scss']
})
export class LoginADFSComponent extends BaseComponent implements OnInit/* , AfterViewInit*/ {
  language: string;
  username: string;
  redirect: string;
  relayState: string;
  baseUser: User = new User();

  constructor(private http: HttpClient, router: Router, route: ActivatedRoute,
              private loginService: LoginService, private userService: UserService,
              private loaderService: LoaderService, private formBuilder: FormBuilder) {
    super(route, router);

    this.username = route.snapshot.params.username;

    this.redirect = sessionStorage.getItem(this.SESSION_STORAGE.REDIRECT);
  }

  ngOnInit() {
    const user = new User();
    user.username = this.username;
    if (!sessionStorage.getItem('authToken')) {
      if (this.username) {
        this.loginService.getAccessToken(this.username.toUpperCase(), this.username.toUpperCase()).subscribe(response => {
          if (sessionStorage.getItem(this.SESSION_STORAGE.TOKEN)) {
            return this.loginService.getUserByUsername(null, user).subscribe((result) => {
              if (sessionStorage.getItem(this.SESSION_STORAGE.USER_ID) !== '') {
                sessionStorage.setItem(this.SESSION_STORAGE.USER_ID, result.id.toString());
                sessionStorage.setItem('user', JSON.stringify(result));
                return this.baseRouter.navigate([this.redirect ? this.redirect : this.LINKS.HOMEPAGE]);
              } else {
                return this.baseRouter.navigate([this.LINKS.UNAUTHORIZED]);
              }
            });
          }
        }, error => {
          this.baseRouter.navigate([this.LINKS.UNAUTHORIZED]);
        });
      } else {
        window.location.href = urlDev + this.LINKS.SSO_LOGIN + '/';

      }
    } else {
      this.baseRouter.navigate([this.redirect ? this.redirect : this.LINKS.HOMEPAGE]);
    }
  }

  async getCurrentUser() {
    return this.userService.currentUser().then(response => {
      sessionStorage.setItem(this.SESSION_STORAGE.USER_ID, response.id.toString());
      console.log(response);
      sessionStorage.setItem('user', JSON.stringify(response));
    });
  }

}
